import React, { ReactNode, SFC } from 'react';
import Magnet, { MagnetProps } from '../Magnet';
import Paper, { PaperProps } from '../Paper';
import { WithStyles, createStyles, withStyles } from '../styles';
import { cx } from '../utils';

const styles = createStyles<'root' | 'out'>(theme => ({
  root: {
    ...theme.font('control'),
    background: theme.color('background.paper'),
    borderRadius: 3,
    cursor: 'auto',
    display: 'inline-block',
    position: 'relative',
    zIndex: 1,
  },
  out: {
    pointerEvents: 'none',
  },
}));

export interface FlyoutWrapperProps
  extends Pick<MagnetProps, Exclude<keyof MagnetProps, 'children'>>,
    Pick<PaperProps, 'elevation'> {
  children?: ReactNode;
  in?: boolean;
}

type Props = WithStyles<FlyoutWrapperProps, typeof styles>;

const FlyoutWrapper: SFC<Props> = ({
  children,
  classes,
  className,
  elevation,
  theme,
  in: isIn,
  domRef,
  ...rest
}) => (
  <Magnet className={cx(!isIn && classes.out)} swap slide {...rest}>
    <Paper
      className={cx(classes.root, className)}
      elevation={elevation}
      domRef={domRef}
    >
      {children}
    </Paper>
  </Magnet>
);

export default withStyles(styles)(FlyoutWrapper);
